// import * as React from "react";
import React, { useCallback, useEffect, useState, useRef } from "react";

import { styled, alpha } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import InputBase from "@mui/material/InputBase";
import LogoutIcon from "@mui/icons-material/Logout";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import { Grid, MenuItem, CircularProgress, Tooltip, Dialog, DialogTitle, DialogContent, DialogActions, Button, Slider } from "@mui/material";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import EasyCropper from "react-easy-crop";
const Cropper = EasyCropper as any;


import byrneIcon from "../../Assets/Images/Byrne-logo.png";
import "./header.css";
import useCustom from "../Hooks/useCustom";
import account from "../../Assets/Images/accountNew.svg";
import banner from "../../Assets/Images/bannerviewNew.svg";
import admin from "../../Assets/Images/adminNew.svg";
import Email from "../../Assets/eventSearch/mail_svg 1.svg";
import signOut from "../../Assets/eventSearch/Signout_svg 1.svg";
import userimg from "../../Assets/Images/User-150.svg";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { useGetEmployeeDetailsByEmailQuery, useGetEmployeeMasterDataQuery, useUpdateEmployeeProfileIconDataMutation } from "../../Services/APIs";

import { fontSize } from "@mui/system";
// import { useHistory } from "react-router-dom";

interface type {
  onClose: () => void;
}
interface IFolderProps {
  data: any;
  error: any;
  isLoading: any;
  CountData: any;
  CountError: any;
  CountLoading: any;
  UserData: any;
  UserError: any;
  UserLoading: any;
  EmpData: any;
  EmpSuccess: any;
  EmpLoading: any;
}

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(3),
    width: "auto",
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "white !important",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    // color: "white !important",
    [theme.breakpoints.up("md")]: {
      width: "50ch",
      border: "1px solid white",
      borderRadius: "5px",
      height: "10px",
      // paddingTop: "5px",
      marginTop: "0px",
      fontSize: "14px",
      color: "#6c6d70 !important",
    },
  },
}));

// const Header = () => {

const Header: React.FC<IFolderProps> = (props: IFolderProps) => {
  let navigate = useNavigate();
  const location = useLocation();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const {
    data,
    error,
    isLoading,
    CountData,
    CountError,
    CountLoading,
    UserData,
    UserError,
    UserLoading,
    EmpData,
    EmpSuccess,
    EmpLoading,
  } = props;
  const { instance, inProgress, accounts } = useMsal();
  const [anchorEl5, setAnchorEl5] = React.useState<null | HTMLElement>(null);
  const open5 = Boolean(anchorEl5);
  const handleClick5 = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl5(event.currentTarget);
  };
  const handleClose5 = () => {
    setAnchorEl5(null);
  };
  const [userName, setUserName] = useState("");
  const [userEmail, setUserEmail] = useState("");  
  //const { instance, accounts, inProgress } = useMsal();
  const acccount = accounts[0];
  const loggedInUser = acccount.name;
  const loggedInUserEmail = acccount.username || "";
  const { data: employeeData, isSuccess } = useGetEmployeeDetailsByEmailQuery(loggedInUserEmail);
  const [updateEmployeeProfileIcon] = useUpdateEmployeeProfileIconDataMutation();
  const profileFileInputRef = useRef<HTMLInputElement>(null);
  const [isUploadingHeader, setIsUploadingHeader] = useState(false);
  const [headerProfileIcon, setHeaderProfileIcon] = useState<string | null>(null);
  const [headerUploadError, setHeaderUploadError] = useState("");
  const [isHoveringPhoto, setIsHoveringPhoto] = useState(false);

  // States for Image Cropping
  const [cropImageSrc, setCropImageSrc] = useState<string | null>(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState<any>(null);
  const [isCropDialogOpen, setIsCropDialogOpen] = useState(false);

  const createImage = (url: string): Promise<HTMLImageElement> =>
    new Promise((resolve, reject) => {
      const image = new Image();
      image.addEventListener("load", () => resolve(image));
      image.addEventListener("error", (error) => reject(error));
      image.setAttribute("crossOrigin", "anonymous"); // avoid cross-origin canvas pollution
      image.src = url;
    });

  const getCroppedImg = async (imageSrc: string, pixelCrop: any): Promise<Blob> => {
    const image = await createImage(imageSrc);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    if (!ctx) throw new Error("No 2d context");

    canvas.width = pixelCrop.width;
    canvas.height = pixelCrop.height;

    ctx.drawImage(
      image,
      pixelCrop.x,
      pixelCrop.y,
      pixelCrop.width,
      pixelCrop.height,
      0,
      0,
      pixelCrop.width,
      pixelCrop.height
    );

    return new Promise((resolve, reject) => {
      canvas.toBlob((blob) => {
        if (!blob) {
          reject(new Error("Canvas is empty"));
          return;
        }
        resolve(blob);
      }, "image/jpeg");
    });
  };

  const handleHeaderPhotoUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const allowedTypes = ["image/jpeg", "image/png", "image/webp"];
    if (!allowedTypes.includes(file.type)) {
      setHeaderUploadError("Only JPG, PNG or WEBP images supported.");
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      setHeaderUploadError("Image must be less than 5MB.");
      return;
    }
    setHeaderUploadError("");

    // Read the file as a data URL to feed into react-easy-crop
    const reader = new FileReader();
    reader.addEventListener("load", () => {
      setCropImageSrc(reader.result as string);
      setIsCropDialogOpen(true);
    });
    reader.readAsDataURL(file);

    // Reset file input ref value so file change is triggered even on same file selection
    if (profileFileInputRef.current) profileFileInputRef.current.value = "";
    handleClose5();
  };

  const handleCropComplete = useCallback((croppedArea: any, croppedAreaPixels: any) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleCropConfirm = async () => {
    if (!cropImageSrc || !croppedAreaPixels) return;
    setIsCropDialogOpen(false);
    setIsUploadingHeader(true);
    try {
      const croppedBlob = await getCroppedImg(cropImageSrc, croppedAreaPixels);
      const formData = new FormData();
      formData.append("profileIcon", croppedBlob, "profile_pic.jpg");
      formData.append("employeeEmail", loggedInUserEmail);

      const result = await updateEmployeeProfileIcon(formData).unwrap();
      if (result?.updatedEmployee?.profileIcon) {
        setHeaderProfileIcon(result.updatedEmployee.profileIcon);
      }
    } catch (err) {
      setHeaderUploadError("Upload failed. Please try again.");
      console.error("Header profile upload error:", err);
    } finally {
      setIsUploadingHeader(false);
      setCropImageSrc(null);
    }
  };

  console.log(employeeData, "employeeData");

  useEffect(() => {
    if (isSuccess && employeeData) {
      // Assuming `account` is supposed to be passed as a prop
      // Replace with the actual source of account data

      // const loggedInUser = employeeData.find(
      //   (employee: { employeeEmail: string }) =>
      //     employee.employeeEmail === loggedInUserEmail
      // );

      const loggedInUser = employeeData;
      if (loggedInUser) {
        setUserName(loggedInUser.employeeName);
        setUserEmail(loggedInUser.employeeEmail);
      }
    }
    console.log(loggedInUserEmail, "loggedInUser.employeeEmail", loggedInUser);
  }, [isSuccess, employeeData]);
  //console.log(loggedInUserEmail,"loggedInUser.employeeEmail")
  // const handleSignout = () => {
  //   instance.logout();
  //   window.location.href = "/welcome";
  // };
  // const handleSignout = () => {
  //   instance.logout();
  //   localStorage.setItem('isLoggedIn', 'false');
  //   window.location.href = '/welcome';
  // };

  // const navigate = useNavigate();

  const handleSignOut = async () => {
    if (instance) {
      try {
        console.log("Attempting to sign out...");
        await instance.logoutPopup();
        console.log("Sign out successful.");

        // Notify other tabs about sign-out
        window.localStorage.setItem("isLoggedIn", "false");
        window.localStorage.setItem("signOut", Date.now().toString());

        // Redirect to login or home page
        window.location.href = "/";
      } catch (error) {
        console.error("Sign out error:", error);
      }
    }
  };



//previous signout
  // const handleSignout = () => {
  //   instance.logoutRedirect().then(() => {
  //     localStorage.setItem("isLoggedIn", "false");
  //   }).catch((error) => {
  //     console.error("Logout failed:", error);
  //   });
  // };
  

  // useEffect(() => {
  //   const syncLogout = (event: StorageEvent) => {
  //     if (event.key === "isLoggedIn" && event.newValue === "false") {
  //       // Optionally handle any cleanup here
  //       window.location.reload(); // Or redirect to login page
  //     }
  //   };
  
  //   window.addEventListener("storage", syncLogout);
  
  //   return () => {
  //     window.removeEventListener("storage", syncLogout);
  //   };
  // }, []);
  

  // useEffect(() => {
  //   const syncLogout = (event: any) => {
  //     if (event.key === "isLoggedIn" && event.newValue === "false") {
  //       instance.logout();
  //       window.location.href = "/welcome";
  //     }
  //   };

  //   window.addEventListener("storage", syncLogout);

  //   return () => {
  //     window.removeEventListener("storage", syncLogout);
  //   };
  // }, [instance]);

  const navigateToEmployeMaster = () => {
    setAnchorEl5(null);
    navigate("/employeeMaster");
  };
  const { token } = useCustom();

  // console.log(data?.response, "user birthday");
  const open = Boolean(anchorEl);
  const handleClick = () => {
    // This will refresh the page
    window.location.href = "/";
  };
  const [searchQuery, setSearchQuery] = useState(""); 
  const [submittedQuery, setSubmittedQuery] = useState(''); 
  const searchInputRef = useRef<HTMLInputElement | null>(null);
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value); // Update searchQuery as you type
  };

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      // Set submitted query and navigate to /searchEvent
      setSubmittedQuery(searchQuery); // Capture the query
      sessionStorage.setItem("lastQuery",searchQuery)
      // navigate(`/searchEvent?query=${encodeURIComponent(searchQuery)}`);
      navigate(`/searchEvent`)
    }
  };


  const handleSearchClick = () => {
    // Set submitted query and navigate when the search icon is clicked
    setSubmittedQuery(searchQuery); // Capture the query
    sessionStorage.setItem("lastQuery",searchQuery)
    // navigate(`/searchEvent?query=${encodeURIComponent(searchQuery)}`);
    navigate(`/searchEvent`)
  };
 
  const handleClickOutside = (event: MouseEvent) => {
    // Check if the click is outside the search input
    if (searchInputRef.current && !searchInputRef.current.contains(event.target as Node)) {
      setSearchQuery(""); // Reset search query
    }
  };

  useEffect(() => {
    // Add event listener for clicks
    document.addEventListener("click", handleClickOutside);
    return () => {
      // Cleanup the event listener
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    if (location.pathname === "/searchEvent") {
      setSearchQuery(""); // Reset search query
    }
  }, [location.pathname]);
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static" className="headerAppbar">
        <Toolbar className="toolbarDiv">
          <Grid
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "row",
              width: "100%",
              alignItems: "center",
              padding: "0px 6px 0px 7px",
              height: "40px",
            }}
          >
            <div>
              <Link to="/">
                <img
                  src={byrneIcon}
                  alt="Byrne Logo"
                  style={{
                    width: "85px",
                    height: "35px",
                    top: "3px",
                    position: "relative",
                    borderRadius: "5px",
                  }}
                  onClick={handleClick}
                />
              </Link>
            </div>
            {/* <Link
              to="/searchEvent"
              style={{ textDecoration: "none", cursor: "pointer" }}
            >
              <Search style={{ backgroundColor: 'white' }}>
                <SearchIconWrapper>
                <SearchIcon style={{ color: 'grey' }} />
                </SearchIconWrapper>
                <StyledInputBase
                  placeholder="Search here…"
                  inputProps={{ "aria-label": "search" }}
                  style={{ color: '#6c6d70 !important' }}
                />
              </Search>
            </Link> */}
            {location.pathname !== "/searchEvent" && (
              // <Link
              //   to="/searchEvent"
              //   style={{ textDecoration: "none", cursor: "pointer" }}
              // >
              //   <Search style={{ backgroundColor: "#ebebeb" }}>
              //     <SearchIconWrapper>
              //       <SearchIcon style={{ color: "grey" }} />
              //     </SearchIconWrapper>
              //     <StyledInputBase
              //       placeholder="Search here…"
              //       inputProps={{ "aria-label": "search" }}
              //       style={{ color: "#6c6d70 !important" }}
              //     />
              //   </Search>
              // </Link>
              <Search style={{ backgroundColor: '#ebebeb' }}>
              <SearchIconWrapper>
                <IconButton onClick={handleSearchClick}>
                  <SearchIcon style={{ color: 'grey' }} />
                </IconButton>
              </SearchIconWrapper>
              <StyledInputBase
                placeholder="Search here…"
                ref={searchInputRef}
                inputProps={{ 'aria-label': 'search' }}
                style={{ color: '#6c6d70 !important' }}
                value={searchQuery} // Controlled input field
                onChange={handleSearchChange} // Update state on change
                onKeyDown={handleKeyPress} // Trigger search on Enter key press
              />
            </Search>
            )}
            {/* <Box sx={{ flexGrow: 1 }} /> */}

            {/* <IconButton
              size="small"
              aria-label="show more"
              aria-haspopup="true"
              color="inherit"
              style={{ fontSize: "12px !important" }}
            >
              <LogoutIcon />{" "}
              <span style={{ paddingLeft: "10px", fontSize: "12px" }}>
                {" "}
                LOGOUT
              </span>
            </IconButton> */}
            <Tooltip title={isUploadingHeader ? "Uploading..." : "Profile"}>
              <IconButton
                size="small"
                edge="end"
                aria-label="account of current user"
                color="inherit"
                id="basic-button"
                aria-controls={open ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleClick5}
                style={{ position: "relative" }}
              >
                <img
                  src={headerProfileIcon || ((employeeData?.profileIcon) ? employeeData?.profileIcon : userimg)}
                  alt="pic"
                  style={{
                    width: "35px",
                    height: "35px",
                    borderRadius: "30px",
                    objectFit: "cover",
                    opacity: isUploadingHeader ? 0.5 : 1,
                  }}
                />
                {isUploadingHeader && (
                  <CircularProgress size={16} style={{ color: "#fff", position: "absolute" }} />
                )}
              </IconButton>
            </Tooltip>

            <Menu
              id="basic-menu"
              anchorEl={anchorEl5}
              open={open5}
              onClose={handleClose5}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
              PaperProps={{
                style: {
                  marginTop: -2,
                },
              }}
              slotProps={{
                paper: {
                  elevation: 0,
                  sx: {
                    overflow: 'visible',
                    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                    mt: 1.5,
                    '& .MuiAvatar-root': {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    '&::before': {
                      content: '""',
                      display: 'block',
                      position: 'absolute',
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: 'background.paper',
                      transform: 'translateY(-50%) rotate(45deg)',
                      zIndex: 0,
                    },
                  },
                },
              }}
              transformOrigin={{ horizontal: 'right', vertical: 'top' }}
              anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
              <Box className="userDetailsGrid">
                {/* Profile photo with hover camera overlay */}
                <div
                  style={{ position: "relative", display: "inline-block", cursor: "pointer" }}
                  onMouseEnter={() => setIsHoveringPhoto(true)}
                  onMouseLeave={() => setIsHoveringPhoto(false)}
                  onClick={() => profileFileInputRef.current?.click()}
                >
                  <img
                    src={headerProfileIcon || ((employeeData?.profileIcon) ? employeeData?.profileIcon : userimg)}
                    alt="pic"
                    style={{
                      width: "50px",
                      height: "50px",
                      borderRadius: "30px",
                      objectFit: "cover",
                      opacity: (isHoveringPhoto || isUploadingHeader) ? 0.6 : 1,
                      transition: "opacity 0.2s",
                    }}
                  />
                  {/* Camera overlay on hover */}
                  {(isHoveringPhoto || isUploadingHeader) && (
                    <div style={{
                      position: "absolute", top: 0, left: 0,
                      width: "50px", height: "50px",
                      borderRadius: "30px",
                      display: "flex", alignItems: "center", justifyContent: "center",
                    }}>
                      {isUploadingHeader
                        ? <CircularProgress size={18} style={{ color: "#e0001b" }} />
                        : <CameraAltIcon style={{ color: "#888", fontSize: 20 }} />
                      }
                    </div>
                  )}
                </div>
                <div style={{ color: "#6C6D70", fontSize: "14px", padding:"5px", cursor: "default" }}>
                {loggedInUser}
                </div>
              </Box>
              {headerUploadError && (
                <div style={{ color: "#e0001b", fontSize: "11px", padding: "0 16px 6px", textAlign: "center" }}>
                  {headerUploadError}
                </div>
              )}
              {/* Hidden file input */}
              <input
                ref={profileFileInputRef}
                type="file"
                accept="image/jpeg,image/png,image/webp"
                style={{ display: "none" }}
                onChange={handleHeaderPhotoUpload}
              />

              {/* <MenuItem className="profile" style={{ cursor: "pointer" }}>
                <img src={admin} alt="account" /> {employeeData?.designation}
              </MenuItem> */}
              {/* <MenuItem onClick={handleClose5} className="profile">
                <img src={account} alt="account" /> Manage your account
              </MenuItem>
              <MenuItem onClick={handleClose5} className="profile">
                <img src={admin} alt="account" />
                Admin
              </MenuItem> */}
              <MenuItem className="profile">
                <img src={Email} alt="E-mail" /> {loggedInUserEmail}
              </MenuItem>
              {employeeData?.roles?.employeeAdmin &&
                <MenuItem onClick={navigateToEmployeMaster} className="profile1">
                  <img src={account} alt="account" /> Employee master
                </MenuItem>
              }
              {/* <MenuItem onClick={handleClose5} className="profile">
                <img src={banner} alt="account" />
                Display on your banner view
              </MenuItem> */}
              <div className="signout">
                <MenuItem onClick={handleSignOut} className="profile profileSignout">
                  <img src={signOut} alt="account" />
                  Sign out
                </MenuItem>
              </div>
            </Menu>

            {/* Interactive Image Crop Dialog */}
            <Dialog
              open={isCropDialogOpen}
              onClose={() => setIsCropDialogOpen(false)}
              maxWidth="sm"
              fullWidth
            >
              <DialogTitle>Crop Profile Photo</DialogTitle>
              <DialogContent style={{ position: "relative", height: 350, backgroundColor: "#f0f0f0", padding: 0 }}>
                {cropImageSrc && (
                  <Cropper
                    image={cropImageSrc}
                    crop={crop}
                    zoom={zoom}
                    aspect={1}
                    cropShape="round"
                    showGrid={false}
                    onCropChange={setCrop}
                    onZoomChange={setZoom}
                    onCropComplete={handleCropComplete}
                  />
                )}
              </DialogContent>
              <DialogActions style={{ flexDirection: "column", padding: "16px 24px", gap: "10px" }}>
                <div style={{ width: "100%", display: "flex", alignItems: "center", gap: "15px" }}>
                  <span style={{ fontSize: "14px", color: "#6C6D70" }}>Zoom</span>
                  <Slider
                    value={zoom}
                    min={1}
                    max={3}
                    step={0.1}
                    aria-labelledby="Zoom"
                    onChange={(e, val) => setZoom(val as number)}
                    style={{ color: "#e0001b" }}
                  />
                </div>
                <div style={{ display: "flex", justifyContent: "flex-end", width: "100%", gap: "10px", marginTop: "10px" }}>
                  <Button onClick={() => setIsCropDialogOpen(false)} style={{ color: "#6C6D70" }}>
                    Cancel
                  </Button>
                  <Button
                    onClick={handleCropConfirm}
                    variant="contained"
                    style={{ backgroundColor: "#e0001b", color: "#fff" }}
                  >
                    Crop & Upload
                  </Button>
                </div>
              </DialogActions>
            </Dialog>

          </Grid>
        </Toolbar>
      </AppBar>
    </Box>

  );
};

export default Header;
